export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "edit-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "confirm-edit-modal-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Êtes-vous sûr de vouloir modifier cet élément?"])}
      },
      "en": {
        "edit-button-label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "confirm-edit-modal-title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you sure you want to edit this item?"])}
      }
    }
  })
}
